import React, { useCallback, useEffect, useState } from 'react'
import { Divider, Grid, TextField, Typography } from '@material-ui/core'
import { Header, Page, CustomButton, SecaoGenerica, ModalConfirmacao } from 'components'
import { cutMaxLength } from 'utils/helpers'
import { FileManager } from 'components/FileManager'
import useRouter from 'utils/useRouter'
import useStyles from './styles'
import { useInformacaoService } from 'hooks/useInformacaoService'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'
import { useParams } from 'react-router'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)
const maxLength4000 = (newValue) => cutMaxLength(newValue, 4000)

const MainForm = (props) => {
  const { route, arquivos, children } = props
  const router = useRouter()
  const classes = useStyles()
  const informacaoService = useInformacaoService()
  const [assunto, setAssunto] = useState('')
  const [descricao, setDescricao] = useState('')
  const [isFormError, setIsFormError] = useState(false)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [espelhoAberto, setEspelhoAberto] = useState(false)
  const params = useParams()

  const confirmarOperacao = useCallback(async () => {
    const id_cadaver = route.origem === 'CADAVER' ? params.idObjeto : null
    const id_periciando = route.origem === 'PERICIANDO' ? params.idObjeto : null
    const id_local = route.origem === 'LOCAL' ? params.idObjeto : null
    const id_veiculo = route.origem === 'VEICULO' ? params.idObjeto : null
    const id_vestigio = route.origem === 'VESTIGIO' ? params.idObjeto : null
    const id_exame_solicitado = route.origem === 'EXAME_SOLICITADO' ? params.idObjeto : null
    const id_solicitacao_exame = route.origem === 'SOLICITACAO_EXAME' ? params.idObjeto : null
    const id_caso = route.origem === 'CASO' ? params.idObjeto : null

    const dados = {
      assunto: assunto || null,
      descricao: descricao || null,
      arqs: arquivos,
      id_cadaver,
      id_periciando,
      id_local,
      id_veiculo,
      id_vestigio,
      id_exame_solicitado,
      id_solicitacao_exame,
      id_caso,
    }
    await informacaoService.cadastrarInformacao(dados, setProcessandoOperacao)

    if (route.origem === 'CADAVER') {
      router.history.push(`/casos/caso/cadaver/detalhar/${params.idObjeto}`)
    }

    if (route.origem === 'PERICIANDO') {
      router.history.push(`/casos/caso/periciando/detalhar/${params.idObjeto}`)
    }

    if (route.origem === 'LOCAL') {
      router.history.push(`/casos/caso/local/detalhar/${params.idObjeto}`)
    }

    if (route.origem === 'VEICULO') {
      router.history.push(`/casos/caso/veiculo/detalhar/${params.idObjeto}`)
    }

    if (route.origem === 'VESTIGIO') {
      router.history.push(`/casos/caso/vestigio/detalhar/${params.idObjeto}`)
    }

    if (route.origem === 'EXAME_SOLICITADO') {
      router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${params.idObjeto}`)
    }

    if (route.origem === 'SOLICITACAO_EXAME') {
      router.history.push(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${params.idObjeto}`)
    }

    if (route.origem === 'CASO') {
      router.history.push(`/casos/caso/detalhar/${params.idObjeto}`)
    }
  }, [assunto, descricao, arquivos, route, params, router])

  const handleClickBotaoConfirmaar = useCallback(() => {
    setEspelhoAberto(true)
  }, [])

  useEffect(() => {
    const formError = !assunto.trim() || !descricao.trim()
    setIsFormError(formError)
  }, [assunto, descricao])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />
      <form id="form-informacao" onSubmit={(e) => e.preventDefault()}>
        <Grid container spacing={3} className={classes.fieldGroup}>
          <Grid item xs={12}>
            <TextField
              value={assunto}
              name="assunto"
              variant="outlined"
              label="ASSUNTO"
              fullWidth
              required
              onChange={(e) => setAssunto(maxLength250(e.target.value))}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
              Caracteres restantes: {250 - assunto.length}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              minRows={4}
              multiline
              label="CONTEÚDO DA INFORMAÇÃO"
              name="descricao"
              variant="outlined"
              onChange={(e) => setDescricao(maxLength4000(e.target.value))}
              value={descricao}
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
              Caracteres restantes: {4000 - descricao.length}
            </Typography>
          </Grid>
        </Grid>

        <SecaoGenerica titulo="Arquivos Relacionados">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {children}
            </Grid>
          </Grid>
        </SecaoGenerica>

        <Divider style={{ margin: '32px 0 16px 0' }} />

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '12px', justifyContent: 'space-between', alignItems: 'center' }}>
              <CustomButton variant="outlined" colorType="primary" startIcon={<ArrowBackIcon />} onClick={() => router.history.goBack()}>
                Voltar
              </CustomButton>
              <CustomButton variant="contained" colorType="secondary" startIcon={<SaveIcon />} disabled={isFormError} isLoading={processandoOperacao} onClick={handleClickBotaoConfirmaar}>
                Cadastrar Informação
              </CustomButton>
            </div>
          </Grid>
        </Grid>
      </form>

      <ModalConfirmacao
        aberto={espelhoAberto}
        onClose={() => setEspelhoAberto(false)}
        onConfirm={confirmarOperacao}
        processando={processandoOperacao}
        titulo="Confirmação de dados"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
              Assunto
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: '4px' }}>
              {assunto}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginTop: '16px' }}>
            <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
              Conteúdo da informação
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: '4px', whiteSpace: 'pre-wrap' }}>
              {descricao}
            </Typography>
          </Grid>
        </Grid>
      </ModalConfirmacao>
    </Page>
  )
}

export const FormularioInformacao = (props) => {
  const { route } = props
  const [arquivos, setArquivos] = useState([])

  return (
    <MainForm arquivos={arquivos} route={route}>
      <FileManager rotaUpload="/arquivo/informacao" rotaLoadImagem="/arquivo/informacao" setArquivosPai={setArquivos} arquivosIniciais={[]} tipos={['image', 'pdf']} />
    </MainForm>
  )
}
